import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-flex items-center justify-center bg-gray-blue-300 rounded-lg w-full h-full text-2xl font-bold text-gray-bluer-200 uppercase" }

import { toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
        file: {
            type:     Object,
            required: true
        },
        url:  {
            type:     String,
            required: true
        }
    },
  setup(__props) {

const props = __props



const { file, url } = toRefs( props );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(file).file_name.split( '.' ).pop()), 1))
}
}

})